import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const F = "block text-[10px] tracking-widest text-neutral-500 mb-1";
const I = "w-full bg-transparent border border-[color:var(--border)] p-2.5 text-sm";

export default function AdminSettings() {
  const [s, setS] = useState({ brand_name: "", tagline: "", whatsapp_number: "", instagram: "", about: "", owner_email: "" });
  useEffect(() => { api.get("/settings").then((r) => setS({ ...s, ...(r.data || {}) })); }, []);
  const save = async (e) => { e.preventDefault(); await api.put("/settings", s); toast.success("Tersimpan"); };
  return (
    <form onSubmit={save} className="max-w-2xl">
      <h1 className="display text-4xl md:text-6xl mb-6">SETTINGS</h1>
      <div className="space-y-4">
        <div><label className={F}>NAMA BRAND</label><input className={I} value={s.brand_name || ""} onChange={(e) => setS({ ...s, brand_name: e.target.value })} /></div>
        <div><label className={F}>TAGLINE</label><input className={I} value={s.tagline || ""} onChange={(e) => setS({ ...s, tagline: e.target.value })} /></div>
        <div><label className={F}>WHATSAPP</label><input className={I} value={s.whatsapp_number || ""} onChange={(e) => setS({ ...s, whatsapp_number: e.target.value })} /></div>
        <div><label className={F}>INSTAGRAM</label><input className={I} value={s.instagram || ""} onChange={(e) => setS({ ...s, instagram: e.target.value })} /></div>
        <div>
          <label className={F}>OWNER EMAIL (notifikasi order & pertanyaan)</label>
          <input data-testid="owner-email" type="email" className={I} value={s.owner_email || ""} onChange={(e) => setS({ ...s, owner_email: e.target.value })} placeholder="kamu@feralriot.co" />
          <p className="text-[10px] text-neutral-500 mt-1">Setiap order berbayar dan setiap pertanyaan customer akan diteruskan ke email ini.</p>
        </div>
        <div><label className={F}>ABOUT</label><textarea rows={6} className={I} value={s.about || ""} onChange={(e) => setS({ ...s, about: e.target.value })} /></div>
      </div>
      <button data-testid="settings-save" className="mt-6 bg-white text-black px-8 py-3 text-xs tracking-widest">SIMPAN</button>
    </form>
  );
}
